import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, MailIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function CTASection() {
  const benefits = ['SEO-optimized from the start', 'Mobile-friendly responsive design', 'Fast loading speeds', 'Secure hosting included', '30-day support & training', 'Easy content management'];
  return <section id="contact-section" className="py-3 md:py-4 bg-[#212C34]" data-id="element-257">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <div className="max-w-4xl mx-auto text-center" data-id="element-259">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-260">
            Ready to launch your{' '}
            <span className="text-[#3AA6F9]" data-id="element-261">dream website</span>?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-white/90 mb-8" data-id="element-262">
            Get started with a free consultation. We'll discuss your goals,
            budget, and timeline to create the perfect web solution for your
            business.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8 max-w-2xl mx-auto" data-id="element-263">
            {benefits.map((benefit, index) => <div key={index} className="flex items-center justify-start" data-id="element-264">
                <div className="w-5 h-5 rounded-full bg-[#3AA6F9] flex items-center justify-center mr-2 flex-shrink-0" data-id="element-265">
                  <CheckIcon size={12} className="text-white" data-id="element-266" />
                </div>
                <span className="text-white/90 text-left" data-id="element-267">{benefit}</span>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-268">
            <a href="mailto:info@bright-pixxel.com?subject=New Customer Enquiry" className="inline-flex items-center justify-center bg-[#3AA6F9] hover:bg-[#3AA6F9]/90 text-[#0C1B26] px-8 py-4 rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-269">
              <MailIcon size={20} className="mr-2" data-id="element-270" />
              Email Us
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}